module.exports = __webpack_public_path__ + "static/media/cq_mostra b.50f6f917.svg";